<template lang="html">
  <div id="home-page" data-aos="fade">

    <section class="container-fluid banner-section">
      <div v-swiper="bannersOptions" class="swiper swiper-desktop" v-if="banners.pc.length" :instanceName="'carrusel-bann1'" :loadtheme="false">
        <div class="swiper-wrapper">
          <div class="swiper-slide"  v-for="(banner, bdInx) in banners.pc" :key="'bdInx-'+bdInx">
            <a class="d-block placed-backg" v-bind:style="{ backgroundImage: 'url('+banner.imageUrl+')' }">
              <img src="public/images/pages/home/banner.png">
            </a>
          </div>
        </div>

        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </div>

      <div v-swiper="bannersOptions" class="swiper swiper-mobile" v-if="banners.movil.length" :instanceName="'carrusel-bann2'" :loadtheme="false">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(banner, bmInx) in banners.movil" :key="'bmInx-'+bmInx">
            <a class="d-block placed-backg" v-bind:style="{ backgroundImage: 'url('+banner.imageUrl+')' }" :href="banner.url" >
              <img src="public/images/pages/home/banner-m.png">
            </a>
          </div>
        </div>

        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </div>
    </section>

    <section class="about-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-info" data-aos="fade-up" data-aos-delay="150">
            <div class="box-image">
              <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url(public/images/pages/home/about-img-1.jpg)' }"></div>
            </div>

            <h5 class="title">Quienes somos</h5>

            <p>
              Somos una empresa dedicada a la fabricación y comercialización de rollos y láminas de plásticos por el proceso de extrusión, en materiales el proceso de extrusión, en materiales como poliestireno, polietileno, y polipropileno, utilizando resinas vírgenes y de primera calidad con casi 15 años de participación en el mercado.
            </p>
          </div>

          <div class="col-lg-4 col-info" data-aos="fade-up" data-aos-delay="300">
            <div class="box-image">
              <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url(public/images/pages/home/about-img-2.jpg)' }"></div>
            </div>

            <h5 class="title">Nuestros procesos</h5>

            <p>
              Nuestros procesos están diseñados para satisfacer mercados de impresión, termoformado, suaje doblez, y toquelado entre otros atendemos mercados como la industria de la publicidad, el punto de venta, el termoformado de charolas para alimentos y empaques en general.
            </p>
          </div>

          <div class="col-lg-4 col-info" data-aos="fade-up" data-aos-delay="450">
            <div class="box-image">
              <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url(public/images/pages/home/about-img-3.jpg)' }"></div>
            </div>

            <h5 class="title">Nuestra experiencia</h5>

            <p>
              Nuestra experiencia en el conocimiento de los procesos y el mercado nos permite recomendar un producto a la medida de las necesidades de cada cliente, así como desarrollar proyectos especiales tales como colores, coextrusiones anchos, calibres materiales, necesidades de embalaje y entrega.
            </p>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      banners: {
        pc: [
          { imageUrl: 'public/images/pages/home/banner-1.jpg', url: '' },
        ],
        movil:[
          { imageUrl: 'public/images/pages/home/banner-1-m.jpg', url: '' },
        ]
      },

      // == Carousels options ==
      bannersOptions: {
        slidesPerView: 1,
        loop: true,
        speed: 750,
        effect: 'fade',

        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      // == ==
    }
  }
}
</script>
